import styled from 'styled-components'

type Props = {
	size: string
	square?: boolean
}

export const Container = styled.div<Props>`
	position: relative;
	text-align: center;
	/* Set to flex to avoid the text SVG from jumping around at some font scales */
	display: flex;

	letter-spacing: 0;

	border-radius: ${({ square }) => (square ? '0%' : '50%')};

	height: ${({ size }) => size};
	width: ${({ size }) => size};
`
